import { Minus, Plus, Check } from "lucide-react";
import { fmtEur } from "@/lib/quote";

export const ProductStep = ({ title, catalog, categories, selections, setSelections, guestsCount, showQty = () => true }) => {
  const products = catalog.filter((p) => categories.includes(p.category));
  const groups = [...new Set(products.map((p) => `${p.category}|${p.menuGroup}`))];

  const toggle = (p) => setSelections((s) => ({ ...s, [p.id]: s[p.id] ? 0 : 1 }));
  const setQty = (p, qty) => setSelections((s) => ({ ...s, [p.id]: Math.max(0, qty) }));

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-bold text-[#2C1A11]">{title}</h2>
        <p className="text-sm text-[#8a7a6d]">Le voci "a persona" vengono calcolate per {guestsCount} ospiti</p>
      </div>
      {groups.map((g) => {
        const [cat, mg] = g.split("|");
        const items = products.filter((p) => p.category === cat && p.menuGroup === mg);
        return (
          <div key={g}>
            <h3 className="text-xs font-bold uppercase tracking-widest text-[#C85A32] mb-2">
              {categories.length > 1 ? `${cat} · ${mg}` : mg}
            </h3>
            <div className="space-y-2">
              {items.map((p) => {
                const selected = (selections[p.id] || 0) > 0;
                return (
                  <div key={p.id} data-testid={`product-card-${p.id}`}
                    onClick={() => p.unit === "persona" && toggle(p)}
                    className={`bg-white rounded-xl border p-4 flex items-center gap-3 transition-colors ${selected ? "border-[#C85A32] ring-1 ring-[#C85A32]" : "hover:border-[#C85A32]/50"} ${p.unit === "persona" ? "cursor-pointer" : ""}`}>
                    <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center shrink-0 ${selected ? "bg-[#C85A32] border-[#C85A32]" : "border-[#d5c9bc]"}`}
                      onClick={(e) => { e.stopPropagation(); toggle(p); }} data-testid={`product-toggle-${p.id}`}>
                      {selected && <Check className="w-4 h-4 text-white" />}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-sm text-[#2C1A11]">{p.name}</div>
                      <div className="text-xs text-[#8a7a6d]">
                        {fmtEur(p.price)} {p.unit === "persona" ? "/ persona" : "cad."} · IVA {p.vat}%
                      </div>
                      {p.description && <div className="text-xs text-[#4A6B5D] mt-0.5">{p.description}</div>}
                    </div>
                    {p.unit === "fisso" && selected && showQty(p) && (
                      <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                        <button data-testid={`qty-minus-${p.id}`} className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-[#FAF7F2]" onClick={() => setQty(p, (selections[p.id] || 1) - 1)}>
                          <Minus className="w-4 h-4" />
                        </button>
                        <span className="font-mono-num font-bold w-6 text-center">{selections[p.id]}</span>
                        <button data-testid={`qty-plus-${p.id}`} className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-[#FAF7F2]" onClick={() => setQty(p, (selections[p.id] || 1) + 1)}>
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    )}
                    {selected && (
                      <div className="font-mono-num font-bold text-sm text-[#C85A32] shrink-0">
                        {fmtEur(p.price * (p.unit === "persona" ? guestsCount : selections[p.id] || 1))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
